import { isPracticeEntry, type PracticeEntry } from "@common/localPractice";

let selected: PracticeEntry = 200;

export function getPracticeEntry(): PracticeEntry {
	return selected;
}
export function setPracticeEntry(entry: PracticeEntry): void {
	if (!isPracticeEntry(entry)) return;
	selected = entry;
	document.dispatchEvent(new Event("practice-entry-change"));
}
